module.exports = __webpack_public_path__ + "img/activity_other6-2.842a7a5a.jpg";